import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { debounce } from 'throttle-debounce';
import { CUSTOM_ROUTE_CONTROL_CLASS } from '../../constants/styles';
import { CUSTOM_ROUTE_CONTROL_STICKY_LEFT_CLASS } from '../../constants/routeControl/stickyLeftStyles';
import { ERouteControlViewType } from '../../types';
import { BUTTON_LAYOUT, DEFAULT_ROUTE_CONTROL_OPTIONS, DEFAULT_ROUTE_CONTROL_STATE, MULTI_ROUTE_CONFIG } from '../../constants/routeControl';
import { getCloseButtonPosition, getRouteControlOptions, mapRouteReferencePoints } from './helpers';
export var YRouteControl = /*#__PURE__*/function () {
  function YRouteControl(map, mapInstance, options) {
    _classCallCheck(this, YRouteControl);
    _defineProperty(this, "_controls", null);
    _defineProperty(this, "_map", void 0);
    _defineProperty(this, "_mapInstance", void 0);
    _defineProperty(this, "_options", void 0);
    _defineProperty(this, "_fixedPoints", {});
    _defineProperty(this, "_handleActiveRouteChangeDebounced", debounce(20, this._handleActiveRouteChange));
    this._map = map;
    this._mapInstance = mapInstance;
    this._options = options;
  }
  _createClass(YRouteControl, [{
    key: "controls",
    get: function get() {
      if (!this._controls) {
        throw new Error('Панель построения маршрута не инициализирована!');
      }
      return this._controls;
    }

    /** Открыть построение маршрута с инициализацией зависимостей */
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var viewType,
          options,
          routePanelInstance,
          closeButton,
          multiRoute,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              viewType = _args.length > 0 && _args[0] !== undefined ? _args[0] : ERouteControlViewType.default;
              if (!this._controls) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              options = getRouteControlOptions(viewType);
              routePanelInstance = new this._mapInstance.control.RoutePanel({
                options: options
              });
              routePanelInstance.routePanel.options.set(DEFAULT_ROUTE_CONTROL_OPTIONS);
              routePanelInstance.routePanel.state.set(DEFAULT_ROUTE_CONTROL_STATE);
              closeButton = new this._mapInstance.control.Button({
                options: {
                  layout: this._mapInstance.templateLayoutFactory.createClass(BUTTON_LAYOUT),
                  position: getCloseButtonPosition(viewType)
                }
              });
              closeButton.events.add('click', this.destroy.bind(this));
              this._controls = {
                closeButton: closeButton,
                routePanel: routePanelInstance
              };
              this._map.controls.add(routePanelInstance);
              this._map.controls.add(closeButton);
              // NOTE: Пока игнорируем ошибку, при корректном флоу ошибок не будет
              this._applyStyles(viewType).catch(function () {});
              _context.prev = 13;
              _context.next = 16;
              return new Promise(function (resolve, reject) {
                routePanelInstance.routePanel.getRouteAsync().then(resolve, reject);
              });
            case 16:
              multiRoute = _context.sent;
              multiRoute.events.add('activeroutechange', this._handleActiveRouteChangeDebounced.bind(this));
              multiRoute.events.add('update', this._handleRoutesUpdate.bind(this));
              multiRoute.model.events.add('requestsend', this._handleRequestSend.bind(this));
              multiRoute.options.set(MULTI_ROUTE_CONFIG);
              this._handleEventInit();
              _context.next = 28;
              break;
            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](13);
              this.destroy();
              throw _context.t0;
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[13, 24]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }() // ----------------------------------------------------------------------------------------------------
    /** Установить координаты начальной точки маршрута */
  }, {
    key: "setPointFrom",
    value: function setPointFrom(lat, lng) {
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var title = arguments.length > 3 ? arguments[3] : undefined;
      this._updateState({
        from: "".concat(lat, ", ").concat(lng),
        fromEnabled: enabled
      });
      this._fixedPoints.from = title;
    }

    // ----------------------------------------------------------------------------------------------------

    /** Установить координаты конечной точки маршрута */
  }, {
    key: "setPointTo",
    value: function setPointTo(lat, lng) {
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var title = arguments.length > 3 ? arguments[3] : undefined;
      this._updateState({
        to: "".concat(lat, ", ").concat(lng),
        toEnabled: enabled
      });
      this._fixedPoints.to = title;
    }

    // ----------------------------------------------------------------------------------------------------

    /** Установить тип маршрутизации */
  }, {
    key: "setRoutingMode",
    value: function setRoutingMode(mode) {
      this._updateState({
        type: mode
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Очистить состояние построения маршрута и закрыть панель */
  }, {
    key: "destroy",
    value: function destroy() {
      this._map.controls.remove(this.controls.routePanel);
      this._map.controls.remove(this.controls.closeButton);
      this._controls = null;
      this._handleEventDestroy();
    }

    // ----------------------------------------------------------------------------------------------------

    /** Обновить текущее состояние панели построения маршрута */
  }, {
    key: "_updateState",
    value: function _updateState(state) {
      this.controls.routePanel.routePanel.state.set(state);
    }

    // ----------------------------------------------------------------------------------------------------

    /** Применить кастомные стили к панели построения маршрута */
  }, {
    key: "_applyStyles",
    value: function _applyStyles(viewType) {
      var routePanel = this.controls.routePanel;
      var parent = routePanel.getParent();
      return new Promise(function (resolve, reject) {
        if (!parent) {
          reject(new Error('Родительский элемент для панели построения маршрута не был установлен!'));
        } else {
          parent.getChildElement(routePanel).then(function (node) {
            node.classList.add(CUSTOM_ROUTE_CONTROL_CLASS);
            if (viewType === ERouteControlViewType.stickyLeft) {
              node.classList.add(CUSTOM_ROUTE_CONTROL_STICKY_LEFT_CLASS);
            }
            resolve();
          }, reject);
        }
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Применить кастомные заголовки для точек маршрута */
  }, {
    key: "_applyWayPointNames",
    value: function _applyWayPointNames(multiRoute) {
      var _this = this;
      var points = multiRoute.getWayPoints().toArray();
      points.forEach(function (point, idx, arr) {
        var index = point.properties.get('index');

        // Применить заголовок к первой точке маршрута, когда задан заголовок точки from
        if (index === 0 && _this._fixedPoints.from !== undefined) {
          point.properties.set('name', _this._fixedPoints.from);
        }

        // Применить заголовок к последней точке маршрута, когда маршрут состоит хотя бы из двух точек и задан заголовок точки to
        if (index > 0 && index + 1 === arr.length && _this._fixedPoints.to !== undefined) {
          point.properties.set('name', _this._fixedPoints.to);
        }
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк изменения активного маршрута */
  }, {
    key: "_handleActiveRouteChange",
    value: function _handleActiveRouteChange(event) {
      if (!this._options.onActiveRouteChange) {
        return;
      }
      var yaRoute = event.originalEvent.target.getActiveRoute();
      var activeRoute = yaRoute && yaRoute.properties.getAll();
      this._options.onActiveRouteChange(activeRoute);
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк изменения активного маршрута, гарантирующий выполнение 1 раз */
  }, {
    key: "_handleRoutesUpdate",
    value:
    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк успешного обновления маршрута */
    function _handleRoutesUpdate(event) {
      this._applyWayPointNames(event.originalEvent.target);
      if (this._options.onRoutesUpdate) {
        var routesData = event.originalEvent.target.getRoutes().toArray();
        var routes = routesData.map(function (route) {
          return route.properties.getAll();
        });
        var wayPointsData = event.originalEvent.target.getWayPoints().toArray();
        var wayPoints = wayPointsData.map(function (point) {
          return point.properties.getAll();
        });
        var mode = this.controls.routePanel.routePanel.state.get('type');
        this._options.onRoutesUpdate({
          mode: mode,
          routes: routes,
          wayPoints: wayPoints
        });
      }

      // Обновляет активный роут после перестроения маршрута
      this._handleActiveRouteChangeDebounced(event);
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк запроса для построения маршрута */
  }, {
    key: "_handleRequestSend",
    value: function _handleRequestSend(event) {
      if (!this._options.onRequestSend) {
        return;
      }
      var _event$originalEvent = event.originalEvent,
        params = _event$originalEvent.params,
        referencePoints = _event$originalEvent.referencePoints;
      this._options.onRequestSend({
        coordinatesOrder: params.searchCoordOrder,
        mode: params.routingMode,
        points: mapRouteReferencePoints(referencePoints)
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк инициализации панели построения маршрута */
  }, {
    key: "_handleEventInit",
    value: function _handleEventInit() {
      if (!this._options.onInit) {
        return;
      }
      this._options.onInit();
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк закрытия панели построения маршрута */
  }, {
    key: "_handleEventDestroy",
    value: function _handleEventDestroy() {
      if (!this._options.onDestroy) {
        return;
      }
      this._options.onDestroy();
    }

    // ----------------------------------------------------------------------------------------------------
  }]);
  return YRouteControl;
}();